const imgUrl = {
  peaceBulb: require("./homeimages/triangleOne.png"),
  peaceHeart: require("./homeimages/traingleTwo.png"),
  peaceHand: require("./homeimages/traingleThree.png"),

  doveImg: require("./homeimages/dovePeace.png"),

  peaceIcon: require("./homeimages/peacemakerImg.png"),
  huzafirProfile: require("./teamimages/Huzaifa.png"),

  contriIcon: require("./programSchool/school1.png"),
  eligibilityIcon: require("./programSchool/eligibility.png"),
  goalIcon: require("./programSchool/goal.png"),
  goalReachIcon: require("./programSchool/globalReach.png"),

  sdg3Icon: require("./programSchool/SDG-3.jpg"),
  sdg4Icon: require("./programSchool/SDG-4.jpg"),
  sdg5Icon: require("./programSchool/SDG-5.jpg"),
  sdg10Icon: require("./programSchool/SDG-10.jpg"),
  sdg16Icon: require("./programSchool/SDG-16.png"),
  sdg17Icon: require("./programSchool/SDG-17.jpg"),

  peaceKeeperGen: require("./programSchool/peacekeeperBuild.png"),
  campusesMovementBg: require("./programSchool/whyCampuses.png"),

  peaceKeeperGifts: require("./iamprogrammes/giftimages/peaceKeeperGift.png"),
  whyCampuses: require("./programSchool/whyCampuses.png"),

  // innerPeace icon
  forgiveIcon: require("./iamprogrammes/inner-peaceimages/forgiveIcon.png"),

  // footer Icons
  mapImg: require("./footer/map.png"),
  xIcon: require("./footer/x.png"),
  fbIcon: require("./footer/fb.png"),
  instaIcon: require("./footer/insta.png"),
  utubeIcon: require("./footer/utube.png"),
  mailIcon: require("./footer/mail.png"),
  linkedInIcon: require("./footer/linkedin.png"),
  peaceMovImg: require("./footer/peacemoveLogo.png"),
  backButtonIcon: require("./back-button.png"),
  dureLogo: require("./footer/dureLogos.png"),

  qrCode: require("../images/qr-code.png"),
  iamPeaceTextImg: require("../images/iampeacecertificate.png"),

  justiceLogo: require("../images/logos/justice.png"),
  billionaireLogo: require("../images/logos/billionaire.png"),

  teamChart: require("../images/teamimages/teamChart.png"),

  visitingCard2: require("../images/visitingcard/visitingCard_2_N.png"),
  visitingCard3: require("../images/visitingcard/visitingCard_3_N.jpg"),
  visitingCard4: require("../images/visitingcard/visitingCard_4_N.jpg"),

  peaceBgImg: require("../images/peaceBg.png"),

  eventDateImg: require("../images/eventimages/dateEvent.png"),
  eventProfileImg: require("../images/eventimages/teamsProfile.png"),
  iamPeacekeeperBird: require("../images/iampeacekeeperBird.png"),

  //home logo images

  microlab: require("../images/homeimages/logos/Micro-Labs-Limited.png"),
  globalProperty: require("../images/homeimages/logos/D1-11-Global-Property-Holdings.png"),
  bhima: require("../images/homeimages/logos/Bhima-Jewellers-LLC.jpg"),
  fincirc: require("../images/homeimages/logos/Fincirc-International-Management-LLC.png"),
  balpharma: require("../images/homeimages/logos/Bal-Pharma-Limited.png"),
  ecube: require("../images/homeimages/logos/eCube-Ace-LLC-FZ.png"),
  whiteSpoons: require("../images/homeimages/logos/White-Spoons-Restaurant-&-Cafe╠ü-LLC.png"),
  pharmveda: require("../images/homeimages/logos/Pharmaveda.png"),

  chablani: require("../images/homeimages/logos/Rose-Travels-Global-Pvt-Ltd.png"),
  enersynk: require("../images/homeimages/logos/Enersynk-Private-Limited.png"),
  pecan: require("../images/homeimages/logos/Pecan-Estates.png"),
  kridzz: require("../images/homeimages/logos/Kridzz-Toys-Private-Limited.png"),
  deal: require("../images/homeimages/logos/Deal-Key-Properties-LLC.png"),
  blackSwan: require("../images/homeimages/logos/Black-Swan-Business-Setup-Services-LLC.png"),
  kurves: require("../images/homeimages/logos/Kurves.png"),
  siroya: require("../images/homeimages/logos/Siroya-Jewellers-LLC.png"),
  stivaph: require("../images/homeimages/logos/Stivaph-Healthcare-Private-Limited.png"),
  dure: require("../images/homeimages/logos/DURE-Technologies-Private-Limited.png"),
  shukra: require("./homeimages/logos/Shukra-Pharmaceuticals-Limited.png"),

  //team image
  teamChart:require("../images/teamimages/team_chart.png"),
  teamChartMobile:require("../images/teamimages/team_chart_mobile.png"),
  teamChartTablet:require("../images/teamimages/team_chart_tablet.png")
};

export default imgUrl;
